import { initAlpinejs } from './modules/alpinejs';
import { initFancybox } from './modules/fancybox';
import { initSwiper } from './modules/swiper';

document.addEventListener('DOMContentLoaded', function () {
  /* Initialise Alpine.js */
  initAlpinejs();

  /* Initialise Fancybox */
  initFancybox();

  /* Initialise Swiper */
  initSwiper();
});
